module.exports = __webpack_public_path__ + "e820132fbd7e3aecd1669eadbd08c38b.svg";